import * as React from 'react';
import { useNavigate, useOutletContext } from 'react-router-dom';

import { 
  Button, 
  Box, 
  Typography, 
  Container,
  CircularProgress  
} from '@mui/material';

import CheckIcon from '@mui/icons-material/Check';
import * as Decoder from 'jwt-decode';

import { TS_CONSTS, CONST } from '../../utils';
import { Selector, OrderReader } from './internal';
import TrackingWorkspace from './internal/trackingWorkspace';

export default function Main(props) {
  document.title=props.title;
  return <TrackingWorkspace screen='PRODUCTION' renderLegacy={({station,order,onBusy})=><LegacyMain {...props} key={`${station||'legacy'}:${order?.orderNumber||''}`} initialStation={station} initialOrder={order} onBusy={onBusy}/>}/>;
}
const legacyKeys={THREE_D:'D3',MACHINING:'MACHINING',POLISH:'POLISH',PACKAGING:'PACKAGING'};
export function LegacyMain(props) {
  const {Main:Context} = useOutletContext();
  const { title,initialStation,initialOrder,onBusy } = props;

    document.title = title;

    const [area, setArea] = React.useState(()=>legacyKeys[initialStation]?{data:TS_CONSTS.AREAS[legacyKeys[initialStation]]}:undefined);

    React.useEffect(() => {
        if(initialStation)return;
        if(Context.HasArea){
            handleLoad()
            return;
        }
        else{
            setArea(undefined);
        }
    }, [Context.HasArea]);

    const handleLoad = async() => {
        const result = JSON.parse(localStorage.getItem(CONST.STORAGE_KEYS.TS_AREA));

        if(result === null){
            return;
        }

        setArea(result);
    };

    const handleAreaSelection = async(key, start = false) => {
        const selection = {
            data: TS_CONSTS.AREAS[key]
        };

        localStorage.setItem(CONST.STORAGE_KEYS.TS_AREA, JSON.stringify(selection));

        Context.Confirmation(true);
        setArea(selection);
    };

    return(
        <Box
            sx={{
                marginTop: 1,
                display: 'flex',
                flexDirection: 'column',
                padding:2
            }}
        >
            {!area && (
                <Selector select={handleAreaSelection}/>
            )}

            {area && (
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                    }}
                >
                    <Typography variant='h5'>
                        Selected Area
                    </Typography>
                    <Typography variant='h2'>
                        {area.data.name}
                    </Typography>
                    <OrderReader key={area.data.name} AreaInfo={area} initialOrder={initialOrder} onBusy={onBusy}/>
                </Box>
            )}

        </Box>
    );
}
